export default __webpack_public_path__ + "static/media/WashingtonQuestion.3441444e.png";